(() => {
  // Keep keyboard focus visible, but suppress rings inherited during touch quick-add.
  document.addEventListener('pointerdown', () => { document.documentElement.dataset.dfInput = 'pointer'; }, true);
  document.addEventListener('keydown', event => {
    if (!event.metaKey && !event.ctrlKey && !event.altKey) document.documentElement.dataset.dfInput = 'keyboard';
  }, true);
  const icon = (section, playing) => section.querySelector(playing ? '[data-df-pause-icon]' : '[data-df-play-icon]')?.innerHTML || (playing ? 'Ⅱ' : '▶');
  function init(scope = document) {
    scope.querySelectorAll('[data-df-reviews]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const slides = [...section.querySelectorAll('[data-df-review]')];
      let index = 0;
      const show = () => {
        slides.forEach((s, i) => s.hidden = i !== index);
        const count = section.querySelector('[data-df-review-count]');
        if (count) count.textContent = slides.length ? `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}` : '';
      };
      section.querySelectorAll('[data-df-review-step]').forEach(button => button.addEventListener('click', () => {
        if (!slides.length) return;
        index = (index + Number(button.dataset.dfReviewStep) + slides.length) % slides.length;
        show();
      }));
      show();
    });
    scope.querySelectorAll('.df-menu-switch').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const tabs = [...menu.querySelectorAll('[data-df-menu-tab]')];
      function select(tab) {
        tabs.forEach(t => { t.setAttribute('aria-selected', t === tab); t.tabIndex = t === tab ? 0 : -1; });
        menu.querySelectorAll('[data-df-menu-panel]').forEach(panel => panel.hidden = panel.dataset.dfMenuPanel !== tab.dataset.dfMenuTab);
      }
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          select(tabs[next]); tabs[next].focus();
        });
      });
    });
    scope.querySelectorAll('.df-product-form').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = form.querySelector('[type=submit]');
        const status = form.closest('.dm-product-card').querySelector('.df-cart-status');
        if (button.disabled) return;
        button.disabled = true; status.textContent = ''; status.hidden = true;
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Toevoegen is niet gelukt. Probeer het opnieuw.');
          document.dispatchEvent(new CustomEvent('dymac:cart:open'));
        } catch (error) { status.textContent = error.message; status.hidden = false; }
        finally { button.disabled = false; }
      });
    });
    scope.querySelectorAll('[data-df-social]').forEach(setupFeed);
  }
  function setupFeed(section) {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const posts = section.querySelector('[data-df-posts]');
    const empty = section.querySelector('[data-df-feed-empty]');
    let visible = new Set();
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      const video = entry.target;
      if (entry.isIntersecting) {
        visible.add(video);
        if (section.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches && !video.dataset.userPaused && !document.hidden) video.play().catch(() => {});
      } else { visible.delete(video); video.pause(); }
    }), { threshold: .5 });
    function videos() {
      section.querySelectorAll('video').forEach(video => {
        if (video.dataset.dfReady) return;
        video.dataset.dfReady = 'true'; video.muted = true; video.defaultMuted = true; video.controls = false; video.playsInline = true; video.setAttribute('muted', ''); video.setAttribute('playsinline', ''); video.removeAttribute('controls'); video.preload = 'none';
        const card = video.closest('.dm-post') || video.parentElement;
        let button = card.querySelector('[data-df-play]');
        if (!button) { card.style.position = 'relative'; button = document.createElement('button'); button.type = 'button'; button.className = 'df-play'; button.dataset.dfPlay = ''; card.append(button); }
        const sync = () => { const playing = !video.paused; button.innerHTML = icon(section, playing); button.setAttribute('aria-label', section.querySelector(playing ? '[data-df-pause-label]' : '[data-df-play-label]').textContent); button.setAttribute('aria-pressed', String(playing)); };
        button.addEventListener('click', async event => {
          event.preventDefault(); event.stopPropagation();
          if (video.paused) { delete video.dataset.userPaused; video.muted = true; try { await video.play(); } catch { button.setAttribute('aria-label', 'Video kan niet worden afgespeeld'); } }
          else { video.dataset.userPaused = 'true'; video.pause(); }
        });
        video.addEventListener('play', sync); video.addEventListener('pause', sync); video.addEventListener('ended', sync); sync(); observer.observe(video);
      });
      if (posts.children.length || section.querySelector('.df-app-feed')?.children.length) empty.hidden = true;
    }
    const mutationObserver = new MutationObserver(videos);
    mutationObserver.observe(section.querySelector('.df-app-feed'), { childList: true, subtree: true });
    videos();
    section.querySelectorAll('[data-df-social-step]').forEach(button => button.addEventListener('click', () => posts.scrollBy({ left: Number(button.dataset.dfSocialStep) * posts.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' })));
    const onVisibility = () => { if (document.hidden) visible.forEach(v => v.pause()); };
    document.addEventListener('visibilitychange', onVisibility);
    section._dfCleanup = () => { observer.disconnect(); mutationObserver.disconnect(); document.removeEventListener('visibilitychange', onVisibility); section.querySelectorAll('video').forEach(v => v.pause()); };
    const safeUrl = value => { if (typeof value !== 'string' || !value.trim()) return null; try { const url = new URL(value, location.origin); return url.protocol === 'https:' || url.origin === location.origin ? url.href : null; } catch { return null; } };
    const endpoint = safeUrl(section.dataset.feedUrl);
    if (section.dataset.feedUrl && endpoint) {
      fetch(endpoint, { headers: { Accept: 'application/json' }, credentials: 'omit', signal: AbortSignal.timeout(10000) })
        .then(response => { if (!response.ok) throw new Error('Feed unavailable'); return response.json(); })
        .then(result => {
          const feed = Array.isArray(result.data) ? result.data : [];
          const published = post => Number(post.created_time) || Date.parse(post.timestamp || post.created_time || '') || 0;
          const recent = [...feed].sort((a,b) => published(b) - published(a)).slice(0, 6);
          if (!recent.length) return;
          const fragment = document.createDocumentFragment();
          recent.forEach(post => {
            const isVideo = post.type === 'video' || post.media_type === 'VIDEO';
            const image = safeUrl(post.images?.standard_resolution?.url || post.thumbnail_url || (!isVideo ? post.media_url : null));
            const video = isVideo ? safeUrl(post.videos?.standard_resolution?.url || post.media_url) : null;
            const link = safeUrl(post.link || post.permalink || section.querySelector('.dm-social-nav a').href);
            if (!image && !video) return;
            const card = document.createElement('article'); card.className = 'dm-post';
            if (video) { const element = document.createElement('video'); element.src = video; if (image) element.poster = image; element.loop = true; element.muted = true; element.playsInline = true; card.append(element); }
            else { const anchor = document.createElement('a'); anchor.href = link; anchor.target = '_blank'; anchor.rel = 'noopener'; const element = document.createElement('img'); element.src = image; element.loading = 'lazy'; element.alt = post.alt_text || post.caption?.text || 'Dymac op Instagram'; anchor.append(element); card.append(anchor); }
            fragment.append(card);
          });
          if (fragment.children.length) { posts.replaceChildren(fragment); videos(); empty.hidden = true; }
        }).catch(() => { if (!posts.children.length) empty.hidden = false; });
    }
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-df-social]').forEach(s => s._dfCleanup?.()));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.df-support[open]').forEach(d => d.removeAttribute('open')); });
})();
